module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/portofolio.json
// module id = 855
// module chunks = 267543299679510